import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  I2gNgTrackingActionBuilder,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';
import { I2gDialogService } from 'i2g-ng-ui';
import { NavigationService } from 'i2g-ng-utils';
import { ClientsService } from '../../../clients/services/clients.service';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { TrackingDialogNamesEnum } from '../../../tracking/tracking.data';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Component({
  selector: 'app-create-job-dialog',
  templateUrl: 'create-job-dialog.component.html',
  styleUrls: ['create-job-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateJobDialogComponent implements OnInit, AfterViewInit {
  /**
   * translation key for title
   */
  @Input() titleKey: string;
  /**
   * translation key for body
   */
  @Input() bodyKey: string;
  /**
   * given tracking screen name where dialog is shown
   */
  @Input() trackingScreenName: string;
  /**
   * client id to create a new job
   */
  @Input() clientId: string;  
  /**
   * document id to be added to job
   */
  @Input() documentId: string;

  primaryButtonTrackingAction: ITrackingAction;
  secondaryButtonTrackingAction: ITrackingAction;
  trackingObject: ITrackingObject;

  constructor(
    private _dialogService: I2gDialogService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingDispatcher: TrackingDispatcher,
    private _navigationService: NavigationService,
    private _clientsService: ClientsService
  ) {}

  ngOnInit() {
    this.primaryButtonTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'create_job',
      this.trackingScreenName
    );
    this.secondaryButtonTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'not_now',
      this.trackingScreenName
    );
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.create_job
    );
  }

  ngAfterViewInit() {
    const dialogTrackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.create_job
    );
    const dialogPresentedTrackingAction = this._trackingActionBuilder.buildPresented(
      this.trackingScreenName
    );

    this._trackingDispatcher.trackEvent(
      dialogTrackingObject,
      dialogPresentedTrackingAction
    );
  }

  onPrimaryButtonClicked() {
    this._trackingDispatcher.trackEvent(
      this.trackingObject,
      this.primaryButtonTrackingAction
    );

    const queryParams = this.documentId ? { document_id: this.documentId } : {};

    const newJobRoutePath = this._clientsService.buildNewJobRoutePath(
      this.clientId
    );
    this._navigationService.goTo(newJobRoutePath, { queryParams });

    this._dialogService.closeDialog();
  }

  onSecondaryButtonClicked() {
    this._trackingDispatcher.trackEvent(
      this.trackingObject,
      this.secondaryButtonTrackingAction
    );
    this._dialogService.closeDialog();
  }
}
